import { render } from "./StoryItem.vue?vue&type=template&id=9dae72d8&scoped=true&ts=true"
import script from "./StoryItem.vue?vue&type=script&lang=ts"
export * from "./StoryItem.vue?vue&type=script&lang=ts"

import "./StoryItem.vue?vue&type=style&index=0&id=9dae72d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dae72d8"]])

export default __exports__